module.exports = __webpack_public_path__ + "img/screen.a9e774d6.png";